import React from 'react';
const BusinessPlanNavBar = () => <div />;

export default BusinessPlanNavBar;
